import { createContext, useContext, useEffect, useState } from "react";
import { REACT_API_URL, WEBSITE_URL } from "../config";
import Cookies from "js-cookie";
import { getOrgId } from "../hooks/useAuth";
const ClinicScheduleContext=createContext(null);
export function ClinicScheduleProvider({children}){
    const[schedule,setSchedule]=useState(null);
    const[loading,setLoading]=useState(true);
    const[error,setError]=useState(null);
    useEffect(()=>{
        const fetchSchedule=async()=>{
            // const clinicId=Cookies.get("organizationId");
            // const clinicId=getOrgId();
            // console.log(clinicId,"this is the clinicId");
            try {
                setLoading(true);
                // const websiteUrl=`https://femcare.avexa.net/`
                
                // const response=await fetch(`${REACT_API_URL}/clinic-onboarding/clinics/${clinicId}/scheduling`);
                const response= await fetch(`${REACT_API_URL}/clinic-onboarding/clinicdetails?websiteUrl=${WEBSITE_URL}`)
                if(!response.ok){
                    throw new Error("Failed to fetch clinic schedule");
                }
                const data= await response.json();
                setSchedule(data);

            } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
        }
        fetchSchedule();

    },[])
return (
    <ClinicScheduleContext. Provider value={{schedule,loading,error}}>
{children}
    </ClinicScheduleContext. Provider>
)
}
export function useClinicSchedule(){
    return useContext(ClinicScheduleContext)
}
export const splitClinicTiming = (text) => {
  const match = text.match(/^(.+?)\s(\d.*)$/);

  return {
    days: match?.[1] || "",
    timings: match?.[2] || "",
  };
};
